import View from 'mixins/view';
import { siteModel } from 'models/SiteModel';
import reportCommentsAsync from 'repositories/reportCommentsAsync';
import deleteCommentAsync from 'repositories/deleteCommentsAsync';
import CommentSocialMediaView from '@ui/social-media-share-view';
import { scroller as loginBarScroller } from '@ui/login-bar/scroller';

const elements = {
  banMessage: '.c-comments__main--blocked',
  navbar: '.js-DockedHeader-Box',
  moderationTrigger: 'i.settings-icon',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`
            <div class="js-Comment-Action-Box comments-action c-comments-main-box-list-element_actions fn-hidden box-relative">
            </div>
        `));
    }
    buildReplyTrigger() {
        const replyTrigger = $(`
            <a href="#" class="link-naked text-color_appblue box-inline shift-margin_2-right user-actions">Odpowiedz</a>
        `);
        const captureReplyClick = (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (siteModel.get('User').get('isBanned')) {
            $(window).scrollTop($(elements.banMessage).offset().top
            - $(elements.navbar).height());
          } else if (siteModel.isUserLogged()) {
              this.parentNode.setReplyMode(this.getModel());
          } else {
              replyTrigger.addClass('js-BubbleBox-Call');
              loginBarScroller();
          }
        };

        replyTrigger.on('click', captureReplyClick);

        return replyTrigger;
    }
    buildShareWidget() {
        const commentSocialMediaView = new CommentSocialMediaView(this.model);
        this.addChild(commentSocialMediaView);
        commentSocialMediaView.bulkCommentShareTrigger();
        commentSocialMediaView.render();
        return commentSocialMediaView.getRootEl();
    }
    buildEditTrigger() {
        const captureEditClick = (event) => {
            event.preventDefault();
            if (siteModel.isUserLogged()) {
              this.parentNode.setEditMode(this.getModel());
            }
        };
        const editTrigger = $(`
            <a href="#" class="user-actions link-naked text-color_appblue box-inlineq shift-margin_2-right">Edytuj</a>
        `);

        editTrigger.on('click', captureEditClick);

        return editTrigger;
    }
    buildReportTrigger() {
        const captureReportClick = () => {
          document.dispatchEvent(new CustomEvent('ReportComment', {
            detail: {
              id: this.model.get('id'),
              isFlaggedByUser: this.model.get('isFlaggedByUser'),
            }
          }));
        };
        const reportTrigger = $(`
            <i class="js-BubbleBox-Call ui-BubbleBox-Call icon-cross-size_2-color_lightgrey c-comment__report-trigger"></i>
        `);
        reportTrigger.on('click', captureReportClick);

        return reportTrigger;
    }
    render() {
        const User = siteModel.get('User');
        const widgets = [];

        if (!User.isBanned()) {
          const replyTrigger = this.buildReplyTrigger();
          widgets.push(replyTrigger);
        }

        const shareWidget = this.buildShareWidget();
        widgets.push(shareWidget);

        if (User.isAuthorOf(this.model) &&
          !User.isBanned() &&
          !this.model.get('isDeleted')) {
            const editTrigger = this.buildEditTrigger();
            widgets.push(editTrigger);
        }

        // if (User.isInModerationMode()) {
        //
        //   const moderationDeleteWidgetTrigger = this.buildModerationDeleteWidgetTrigger();
        //   this.target = moderationDeleteWidgetTrigger;
        //   widgets.push(moderationDeleteWidgetTrigger);
        //
        //   const moderateWidgetTrigger = this.buildModerateWidgetTrigger();
        //   widgets.push(moderateWidgetTrigger);
        //
        //   const deleteWidgetTrigger = this.buildDeleteWidgetTrigger();
        //   widgets.push(deleteWidgetTrigger);
        // } else {

        const reportTrigger = this.buildReportTrigger();
        widgets.push(reportTrigger);

        // }

        this.getRootEl().append(widgets);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-user-actions-view.js